import { apiRequest } from "./client";

function queryString(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const value = search.toString();
  return value ? `?${value}` : "";
}

export const ordersApi = {
  list(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/orders${queryString(params)}`);
  },

  listKitchen(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/orders/kitchen${queryString(params)}`);
  },

  get(projectId, orderId) {
    return apiRequest(`/projects/${projectId}/orders/${orderId}`);
  },

  closeKitchen(projectId, orderId) {
    return apiRequest(`/projects/${projectId}/orders/${orderId}/kitchen/close`, {
      method: "POST",
    });
  },

  updateStatus(projectId, orderId, status) {
    return apiRequest(`/projects/${projectId}/orders/${orderId}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
    });
  },
};
